// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EmployeeAllowancesSection__wrap--23Gnm"};